import React from 'react';
import { config } from '@mp/config';
import { useProNavigate } from '@mp/contexts';
import { SetYourselfUpInfo } from './SetYourselfUpInfo';

interface SetYourselfUpProps {
  title?: string;
  body?: string;
  iconName?: any;
}

export const SetYourselfUp = ({ title, body, iconName }: SetYourselfUpProps) => {
  const { openUrl } = useProNavigate();
  const onClick = () => openUrl(config.help.setYourselfUpForSuccess);

  return <SetYourselfUpInfo onClick={onClick} title={title} body={body} iconName={iconName} />;
};
